var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "course-listing" }, [
    _c("div", { staticClass: "paywall-courses row paywall-section-gray" }, [
      _c("h2", [_vm._v("60+ courses to choose from")]),
      _vm._v(" "),
      _c("div", { staticClass: "courses row" }, [
        _c(
          "div",
          {
            staticClass: "section-wrapper",
            class: { "hide-preview": !this.expanded }
          },
          _vm._l(_vm.categorizedCourses, function(ref) {
            var category = ref.category
            var courses_grouped_by_difficulty =
              ref.courses_grouped_by_difficulty
            var index = ref.index
            return _c(
              "div",
              {
                key: category + "-" + index,
                staticClass: "section row course"
              },
              _vm._l(courses_grouped_by_difficulty, function(ref) {
                var difficulty = ref.difficulty
                var courses = ref.courses
                return _c(
                  "div",
                  { key: category + "-" + difficulty, staticClass: "category" },
                  [
                    _c("h3", { staticClass: "row" }, [
                      _vm._v(_vm._s(difficulty) + " " + _vm._s(category))
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "unstyled row" },
                      _vm._l(courses, function(course, index) {
                        return _c(
                          "li",
                          { key: course.name + "-" + index },
                          [
                            _c("BriocheImageTag", {
                              attrs: {
                                src: course.intro_image_url,
                                width: 20,
                                alt: course.name
                              }
                            }),
                            _vm._v(
                              "\n                " +
                                _vm._s(course.name) +
                                "\n              "
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                )
              }),
              0
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mini-footer" }, [
        _c(
          "button",
          {
            staticClass: "courses-btn",
            attrs: { href: "#" },
            on: { click: _vm.toggleExpanded }
          },
          [
            _vm._v("\n        See more courses\n        "),
            _c("span", [
              _vm._v(
                "\n          " +
                  _vm._s(this.expanded ? "▲" : "▼") +
                  "\n        "
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }